import { MASK_BRL, MASK_USD } from '@modules/global/constants/Currencies'

const USD_KEYWORDS = ['usd', 'us$', 'dolar', 'dólar']

export const CURRENCY_LABEL_BRL = 'Real'
export const CURRENCY_LABEL_USD = 'Dólar'
export const CURRENCY_LABEL_OPTIONS = [CURRENCY_LABEL_BRL, CURRENCY_LABEL_USD]
export const CURRENCY_CODE_BRL = 'BRL'
export const CURRENCY_CODE_USD = 'USD'

export const normalizeCurrencyText = ({ currency }) => {
  return String(currency || '')
    .trim()
    .toLowerCase()
}

export const isUsdCurrency = ({ currency }) => {
  const normalizedCurrency = normalizeCurrencyText({ currency })

  if (!normalizedCurrency) {
    return false
  }

  return USD_KEYWORDS.some((keyword) => {
    return normalizedCurrency.indexOf(keyword) !== -1
  })
}

export const normalizeCurrencyCode = ({ currency }) => {
  return isUsdCurrency({ currency }) ? CURRENCY_CODE_USD : null
}

export const getCurrencyLabel = ({ currency }) => {
  if (isUsdCurrency({ currency })) {
    return CURRENCY_LABEL_USD
  }

  return CURRENCY_LABEL_BRL
}

export const resolveCurrencyInputType = ({ currency }) => {
  return isUsdCurrency({ currency }) ? 'money_dolar' : 'money'
}

export const prependCurrencyMask = ({ value, currency } = {}) => {
  if (value === null || value === undefined || value === '' || value === '-') {
    return value || '-'
  }

  const text = String(value)
  if (text.includes(MASK_BRL) || text.includes(MASK_USD)) {
    return text
  }

  return `${isUsdCurrency({ currency }) ? MASK_USD : MASK_BRL} ${text}`
}
